import React from "react";
import { useTranslation } from "react-i18next";
import { apiPut, apiGet, apiDelete } from "../../utils/apiFetch"; // Make sure apiDelete is exported in your apiFetch.js
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { AiFillEye, AiFillEdit, AiFillDelete } from "react-icons/ai";
import helpers from "../../utils/helpers";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const ListProcessTable = ({ allGenerateSalary, generateList, handleEdit, handleView, page }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  
  const handelStatusChange = async (item) => {
    try {
      const payload = { status: "paid" };
      const path = `${apiPath.markPaidSalary}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allGenerateSalary();
      }
    } catch (error) {
      console.log("error in get all list==>>>>", error.message);
    }
  };

  const handleDownloadSample = async (item) => {
    try {
      const path = `${apiPath.downloadSlip}`;
      const payload = { id: item?._id };
      const res = await apiGet(path, payload);
      if (res.data.success) {
        helpers.downloadFile(res?.data?.results?.file_path);
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  // NEW: Handle Delete
  const handleDelete = async (item) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this generated salary record?");
    if (!isConfirmed) return;

    try {
      const path = `${apiPath.deleteGenerateSalary}/${item?._id}`;
      const result = await apiDelete(path);
      
      if (result?.data?.success) {
        notification.success(result.data.message || "Deleted successfully");
        allGenerateSalary();
      } else {
        notification.error(result?.data?.message || "Failed to delete");
      }
    } catch (error) {
      console.log("error deleting salary:", error);
      notification.error(error.message || "Something went wrong");
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className=" rounded-lg border overflow-x-auto relative">
          <table className="dark:text-gray-400 w-full text-xs text-left text-[#6c6c6c] ">
            <thead className="bg-[#E1E6EE] text-xs text-gray-900 border border-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("DEPARTMENT")} />
                <TableHeaderCell text={t("DURATION")} />
                <TableHeaderCell text={t("FROM_DATE")} />
                <TableHeaderCell text={t("TO_DATE")} />
                <TableHeaderCell text={t("ALLOWANCE")} />
                <TableHeaderCell text={t("DEDUCTION")} />
                <TableHeaderCell text={t("NET_PAY")} />
                <th scope="col" className="text-center py-3 px-6 ">
                  {t("O_STATUS")}
                </th>
                <th className="py-3 px-6 text-center" scope="col">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {generateList &&
                generateList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.employeeId}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Department?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.JobRequests?.duration}</td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">{dayjs(item?.fromDate).format("MM-DD-YYYY")} </td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">{dayjs(item?.toDate).format("MM-DD-YYYY")} </td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">${item?.totalAllowance + item?.otherAllowance}</td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">${item?.totalDeduction + item?.otherDeduction}</td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">${Number(item?.totalAllowance + item?.otherAllowance) - (item?.totalDeduction + item?.otherDeduction)}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{startCase(item?.status)}</td>
                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center items-center gap-2">
                            {item && item?.status === "pending" && (
                              <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                                <a title="Edit Generate Salary" className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                  <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                </a>
                              </li>
                            )}
                            <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="View employee list">
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" /> 
                              </a>
                            </li>
                            
                            {/* NEW DELETE BUTTON */}
                            <li onClick={() => handleDelete(item)} className="px-2 py-2 hover:bg-red-50 rounded">
                              <a title="Delete Record">
                                <AiFillDelete className="cursor-pointer w-5 h-5 text-red-500" />
                              </a>
                            </li>

                            {item && item?.status === "pending" && (
                              <li>
                                <button
                                  className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                  onClick={() => handelStatusChange(item)}
                                >
                                  Mark As Paid
                                </button>
                              </li>
                            )}
                            <li>
                              <button
                                className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 disabled:opacity-50"
                                disabled={item?.status === "pending" ? true : false}
                                onClick={() => handleDownloadSample(item)}
                              >
                                Pay Slip
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(generateList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={13}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListProcessTable;